// Fill the footer's event line from the loaded /conference metadata rather than a
// hard-coded string, so it tracks the served data (and the server's date-shift) and
// never shows a stale or invented date.

import { store } from "./store/app-state.js";
import { conferenceSummary } from "./lib/conference.js";

// The event metadata is loaded once and immutable for the session, so this subscribes
// only until the summary is first filled in, then UNSUBSCRIBES: no lingering
// app-lifetime subscription. If metadata never arrives (offline, no cache) the span
// just stays empty.
export function initFooter() {
  const el = document.querySelector("[data-conference-summary]");
  if (!(el instanceof HTMLElement)) {
    return;
  }
  const paint = () => {
    const summary = conferenceSummary(store.getState().conference);
    if (!summary) {
      return false;
    }
    el.textContent = summary;
    return true;
  };
  if (paint()) {
    return; // metadata already present, no subscription needed
  }
  const unsubscribe = store.subscribe(() => {
    if (paint()) {
      unsubscribe();
    }
  });
}
